<template>
  <div class="field">
    <label class="label">{{label}}</label>
    <div class="control">
      <div class="ColorFilter">
        <ul class="ColorFilter-list">
          <li class="ColorFilter-listItem ColorFilter-listItem--isChecked ColorFilter-listItem--boxed ColorFilter-listItem--rounded ColorFilter-listItem--shadow" v-for="color in selected" :key="color.colorCode" @click="restore(color)">
            <img class="ColorFilter-listItemImage ColorFilter-listItemImage--cover" :src="color.colorSW">
          </li>
        </ul>
        <div class="ColorFilter-block">
          <ul class="ColorFilter-list">
            <li class="ColorFilter-listItem ColorFilter-listItem--isChecked ColorFilter-listItem--boxed ColorFilter-listItem--rounded ColorFilter-listItem--shadow" v-for="color in colors" :key="color.colorCode" @click="select(color)">
              <img class="ColorFilter-listItemImage ColorFilter-listItemImage--cover" :src="color.colorSW">
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorFilter',
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      colors: this.data.sort((a, b) => a.colorCode - b.colorCode),
      selected: []
    }
  },
  watch: {
    data (data) {
      this.colors = JSON.parse(JSON.stringify(data)).sort((a, b) => a.colorCode - b.colorCode)
      // console.log('colors', data)
    }
  },
  methods: {
    select (color) {
      this.selected.push(color)
      this.selected.sort((a, b) => a.colorCode - b.colorCode)
      this.colors = this.colors.filter(c => c.colorCode !== color.colorCode).sort((a, b) => a.colorCode - b.colorCode)
      this.$emit('input', this.selected)
    },
    restore (color) {
      this.colors.push(color)
      this.colors.sort((a, b) => a.colorCode - b.colorCode)
      this.selected = this.selected.filter(c => c.colorCode !== color.colorCode).sort((a, b) => a.colorCode - b.colorCode)
      this.$emit('input', this.selected)
    }
  }
}
</script>

<style scoped lang="scss">
.ColorFilter {
  &-block {
    background:
    linear-gradient(white 30%, hsla(0,0%,100%, 0)),
    linear-gradient(hsla(0,0%,100%,0) 10px, white 70%) bottom,
    radial-gradient(at top, rgba(0,0,0,0.2), transparent 70%), 
    radial-gradient(at bottom, rgba(0,0,0,0.2), transparent 70%) bottom;
    background-repeat:no-repeat;
    background-size: 100% 20px, 100% 20px, 100% 10px, 100% 10px;
    background-attachment:local, local, scroll, scroll;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    max-height: 120px;
    overflow: auto;
    padding: 12px 0 12px 12px;
    &:hover {
      border-color: #b5b5b5;
    }
    @include from($tablet) {
      max-height: 220px;
    }
  }
  &-list {
    display: block;
  }
  &-listItem {
    border: 1px solid #fff;
    border-radius: 100%;
    border: 1px solid #bbb;
    cursor: pointer;
    display: inline-block;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 40px;
    height: 40px;
    overflow: hidden;
    position: relative;
  }
  &-listItemImage {
    border-radius: inherit;
    border: 2px solid transparent;
    transition: .2s ease;
    height: 100%;
    width: 100%;
    object-fit: cover;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>
